import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { AccountEntryService } from 'api';
import { isSuccessful } from 'api/utils';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { useTranslation } from 'react-i18next';
import { appToast } from 'utils/toast.utils';
import * as S from '../../InvoiceAllocations.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  accountEntryId: number;
  accountEntriesLoading: boolean;
};

export const WithdrawCorrectionAllocationDialog = ({
  open,
  onClose,
  onSubmit,
  accountEntryId,
  accountEntriesLoading,
}: Props) => {
  const { t } = useTranslation(['invoice']);

  const { loading, withdrawCorrectionAccountEntry } =
    AccountEntryService.useWithdrawCorrectionAccountEntry();

  const handleSubmit = async () => {
    const res = await withdrawCorrectionAccountEntry(accountEntryId);
    isSuccessful(res) &&
      appToast.success(t('correctionWithdrawn', { ns: 'invoice' }));
    await onSubmit();
    onClose();
  };

  const isBackdropVisible: boolean = loading || accountEntriesLoading;

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <LoaderFullScreen loading={isBackdropVisible} />
      <DialogTitle>
        {t('modal.withdrawCorrectingAllocationHeading', { ns: 'misc' })}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {t('modal.withdrawCorrectingAllocationBody', { ns: 'misc' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleSubmit}>
          {t('button.accept', { ns: 'misc' })}
        </StyledButton>
        <StyledButton onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
